module.exports = __webpack_public_path__ + "static/whitebg-9526ca19feef67389ddbd1f0cbc0b36a.png";